import DestinationPage from "@/components/DestinationPage";
const related = [
  { name: "Egipt", slug: "egipt", image: "https://images.unsplash.com/photo-1705628080778-f86b2f90a114?w=600&q=80" },
  { name: "Spania", slug: "spania", image: "https://images.unsplash.com/photo-1758471206484-0eaa2568320c?w=600&q=80" },
  { name: "Turcia", slug: "turcia", image: "https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=600&q=80" },
];
export default function ZanzibarPage() {
  return (
    <DestinationPage
      name="Zanzibar" nameRo="Zanzibar" slug="zanzibar" flag="🇹🇿"
      heroImage="https://images.unsplash.com/photo-1559934303-856aae38610f?w=1920&q=80"
      metaTitle="Vacanță în Zanzibar din Chișinău | Paradis Tropical Africa – Premium Style Travel"
      metaDescription="Pachete turistice Zanzibar din Chișinău. Plaje paradisiace, Oceanul Indian, hoteluri boutique. Experiență exotică de neuitat. Sună +373 60609292."
      tagline="Nisip alb ca zahărul, ape turcoaz și apusuri de soare spectaculare — Zanzibar, paradisul ascuns din Oceanul Indian."
      description="Zanzibar este una dintre cele mai exotice și mai puțin bătute destinații turistice accesibile din Africa de Est. Această insulă tanzaniană din Oceanul Indian îmbină plaje impecabile cu o cultură arabă fascinantă în Stone Town (patrimoniu UNESCO). Apa cu temperaturi de 26-28°C tot anul, recifele de corali virgine, mirosul de condimente și ospitalitatea localnicilor fac din Zanzibar o experiență unică. Ideal pentru cupluri în lună de miere, aventurieri și cei care caută ceva diferit."
      highlights={[
        "Stone Town – patrimoniu UNESCO cu arhitectură arabă",
        "Nungwi și Kendwa – cele mai frumoase plaje din insulă",
        "Snorkeling și diving la recifele de corali Mnemba",
        "Safari de o zi în Tanzania (Serengeti, Ngorongoro)",
        "Tururi cu condimente – vanilie, cuișoare, scorțișoară",
        "Dolphin Tour – înot cu delfini în libertate",
        "Prison Island – broaște țestoase gigante",
        "Apusuri de soare spectaculare de pe Dhow (barcă tradițională)",
      ]}
      included={[
        "✈️ Zbor internațional dus-întors din Chișinău",
        "🏨 Cazare hotel boutique / resort pe malul mării",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Consultanță personalizată pentru vize",
      ]}
      faqs={[
        { q: "Cât durează zborul spre Zanzibar?", a: "Aproximativ 8-10 ore cu escală (de obicei Nairobi, Doha sau Dubai). Nu există zbor direct din Chișinău." },
        { q: "Este nevoie de viză pentru Zanzibar?", a: "Da, cetățenii moldoveni au nevoie de viză pentru Tanzania (Zanzibar). Costă ~50 USD și se poate obține la aeroport sau online." },
        { q: "Când este cel mai bun sezon?", a: "Iunie–octombrie și decembrie–februarie sunt perioadele ideale, cu vreme uscată și însorită. Evitați martie–mai (sezonul ploios)." },
        { q: "Este Zanzibar sigur?", a: "Da, Zanzibar este considerată una dintre cele mai sigure destinații din Africa pentru turiști, cu infrastructură turistică bine dezvoltată." },
        { q: "Câte zile sunt recomandate?", a: "Minimum 10 nopți pentru a experimenta complet insula. 14 nopți este ideal dacă adăugați și un safari." },
      ]}
      relatedDestinations={related}
    />
  );
}
